import { Injectable, inject } from '@angular/core';

import { SocketIoService } from '@libs/shared-services';
import { Store } from '@ngrx/store';
import { Socket } from 'socket.io-client';
import { collaborationsActions } from '../../store/collaborations';
import { CollaborationServerEvents } from './interfaces';
import { CollaborationEvents } from './enums';

@Injectable({ providedIn: 'root' })
export class CollaborationListenerService extends SocketIoService<CollaborationServerEvents> {
  protected readonly namespace = '/collaborations';
  protected readonly authentication = true;

  private readonly store = inject(Store);

  public connect(): void {
    this.startSocket();
  }

  protected setupListeners(socket: Socket<CollaborationServerEvents>): void {
    socket.on(CollaborationEvents.ReceiveMessage, (data) => {
      this.store.dispatch(collaborationsActions.wsReceiveMessage({ data }));
    });

    socket.on(CollaborationEvents.DeleteMessage, (data) => {
      this.store.dispatch(collaborationsActions.wsDeleteMessage({ data }));
    });

    socket.on(CollaborationEvents.AddToCollaboration, (data) => {
      this.store.dispatch(collaborationsActions.wsAddToCollaboration({ data }));
    });

    socket.on(CollaborationEvents.ReadCollaboration, (data) => {
      this.store.dispatch(collaborationsActions.wsReadCollaboration({ data }));
    });

    socket.on(CollaborationEvents.InitUnreadCollaborations, (data) => {
      this.store.dispatch(collaborationsActions.wsInitUnreadCollaborations({ data }));
    });

    socket.on(CollaborationEvents.ThumbnailReady, (data) => {
      this.store.dispatch(collaborationsActions.wsThumbnailReady({ data }));
    });

    socket.on('connect', () => {
      this.store.dispatch(collaborationsActions.wsConnectionEstablished());
    });

    socket.on('disconnect', () => {
      this.store.dispatch(collaborationsActions.wsConnectionClosed());
    });

    socket.on('connect_error', () => {
      this.store.dispatch(collaborationsActions.wsConnectionError());
    });
  }
}
